const baseURL = "https://static.yuansiwei.com";
//替换图片
const replaceinfo = str => {
  let newinfo = "",
    string = "";
  //不是字符串转换成字符串
  if (typeof str !== "string") {
    string = JSON.stringify(str);
  } else {
    string = str;
  }
  if (string.includes("images/")) {
    if (string.includes("/images/")) {
      newinfo = string.replace(/\/images\//g, `${baseURL}/images/`);
    } else {
      newinfo = string.replace(/images\//g, `${baseURL}/images/`);
    }
  } else {
    newinfo = string;
  }
  //不是字符串转换为原有对象
  if (typeof str !== "string") {
    newinfo = JSON.parse(newinfo);
  }
  return newinfo;
};

export { replaceinfo };
